module.exports = __webpack_public_path__ + "media/images/vp/icon.addtask.red-0e563eb6184cba94e9ae33ef69b2fc83.svg";